import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import {authProviders, AuthGuard} from '../../auth.guard';

import { ManageBookingComponent } from '../booking/manage-booking/manage-booking.component';
import { RequestAppointmentComponent } from '../booking/request-appointment/request-appointment.component';
import { ListMemberComponent } from './list-member/list-member.component';
import {PendingChangesGuard} from '../../pending-changes.guard';
const bookingRouter: Routes = [
    {
        path: '',
        canActivateChild: [AuthGuard],
        children: [
            { path: 'manage-booking', component: ManageBookingComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'request-appointment', component: RequestAppointmentComponent},
            { path: 'list-member', component: ListMemberComponent}
        ]
    }
];
@NgModule({
    imports: [RouterModule.forChild(bookingRouter)],
    exports: [RouterModule],
    providers: []
})

export class BookingRoutingModule { }


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/booking.routing.ts